import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

import DetailModal from '@/components/refundDetail/DetailModal';
import useGetGlobalStatus from '@/hooks/useGetGlobalStatus';
import { getComma } from '@/util/format';
import { IModal } from '@/components/home/RecentRefund';
import GlobalPaymentCancelButton from './GlobalPaymentCancelButton';
import { PaymentOrderData } from '@/types/payment.type';
import { getPaddedPaymentLogoImage } from '@/util/payment';

interface GlobalPaymentItemProps {
  qrOrder: PaymentOrderData;
  index: number;
  currentPage: number;
  refetch: () => void;
}

function GlobalPaymentItem({
  qrOrder,
  index,
  currentPage,
  refetch,
}: GlobalPaymentItemProps) {
  // 구조 분해 할당
  const { createdDate, qrOrderId, refundId, statusCode, qrOrderAgent, amount } =
    qrOrder;

  const [detailModal, setDetailModal] = useState<IModal>({ isActive: false });

  // 상태 코드에 따른 텍스트 변환
  const getStatusText = (code: string) => {
    const statusMap: Record<string, string> = {
      T000: '완료',
      T001: '취소',
      T002: '취소',
    };
    return statusMap[code] || '-';
  };

  const getRefundStatusText = (refundId: number) => {
    return !!refundId ? '환급 완료' : '-';
  };

  return (
    <>
      <Item>
        {/* 날짜 */}
        <Content active={statusCode === 'T000'} flex={1.6}>
          {createdDate ? format(new Date(createdDate), 'yyyy-MM-dd HH:mm') : ''}
        </Content>

        {/* 환급 상태 - 제거됨 */}
        {/* <Content active={statusCode === 'T000'} flex={1}>
          {getRefundStatusText(refundId)}
        </Content> */}

        {/*결제 상태 */}
        <Content active={statusCode === 'T000'} flex={1.5}>
          {getStatusText(statusCode)}
        </Content>

        {/* 빈 공간 */}
        <Content active={statusCode === 'T000'} flex={3.4}></Content>

        {/* 결제 수단 */}
        <Content active={statusCode === 'T000'} flex={1.65}>
          <PaymentLogo
            active={statusCode === 'T000'}
            src={getPaddedPaymentLogoImage(qrOrderAgent)}
            alt={`${qrOrderAgent} 로고`}
          />
        </Content>

        {/* 금액 */}
        <Content
          active={statusCode === 'T000'}
          flex={1.5}
          style={{
            fontFamily: 'Pretendard',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: '600',
          }}
        >
          {getComma(amount)}원
        </Content>

        {/* 삭제 버튼 */}
        <Content flex={1}>
          <GlobalPaymentCancelButton
            qrOrderId={qrOrderId}
            cancelAmount={Number(amount)}
            isQrOrderCancelled={statusCode !== 'T000'}
            qrOrderAgent={qrOrderAgent}
            paymentDate={createdDate}
          />
        </Content>
      </Item>

      {/* 상세 정보 모달 */}
      {detailModal.isActive && (
        <DetailModal
          refund={detailModal.data}
          setUploadModal={setDetailModal}
        />
      )}
    </>
  );
}

// 스타일 컴포넌트
const Item = styled.li`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${(props) => props.theme.mono[10]};
  background-color: ${(props) => props.theme.pointColors.white};

  &:last-child {
    border-bottom: none;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }

  &:hover {
    background-color: #e9f0fe;
  }
`;

const Content = styled.div<{
  flex: number;
  active?: boolean;
  isKioskStore?: boolean;
}>`
  color: ${(props) =>
    props.isKioskStore && props.active
      ? props.theme.blue[200]
      : props.active
      ? props.theme.mono[80]
      : props.theme.mono[35]};
  position: relative;
  display: flex;
  flex: ${(props) => props.flex};
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 12px 8px;
  box-sizing: border-box;

  @media ${(props) => props.theme.mediumView} {
    padding: 12px 20px;
  }
`;

const PaymentLogo = styled.img<{ active?: boolean }>`
  height: 46px;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
`;

export default GlobalPaymentItem;
